import React from 'react';
import { Link } from 'react-router-dom';
import styles from './imposto.module.css';

import imagemImposto1 from './img/imposto1.jpg';
import imagemImposto2 from './img/imposto2.jpg';

function ImpostoRendaBlog() {
  return (
    <div className={styles.paginaMateria}>
      <div className={styles.containerInterno}>
        
        <Link to="/blog" className={styles.btnVoltar}>
          &larr; Voltar para o Portal
        </Link>

        <header className={styles.cabecalhoMateria}>
          <span className={styles.tagMateria}>Atualização Tributária</span>
          <h1>Declaração de Imposto de Renda Pessoa Física (DIRPF) 2026: Aspectos Fundamentais e Novas Diretrizes</h1>
          <p className={styles.subtitulo}>Nossa equipe de especialistas analisa as principais normativas e as práticas essenciais para a conformidade fiscal no exercício de 2026.</p>
          <span className={styles.dataPublicacao}>Publicado em 20 de Março de 2026</span>
        </header>

        <div className={styles.imagemDestaque}>
          <img src={imagemImposto1} alt="Análise da declaração de imposto de renda" />
        </div>

        <article className={styles.conteudoTexto}>
          <p>
            O início do exercício fiscal de 2026 impõe aos contribuintes brasileiros a necessidade de atenção rigorosa às diretrizes estabelecidas pela Secretaria da Receita Federal do Brasil. A correta apresentação da Declaração de Ajuste Anual do Imposto sobre a Renda da Pessoa Física (DIRPF) é indispensável não apenas para o cumprimento da obrigação tributária principal, mas também para a manutenção da regularidade fiscal do CPF.
          </p>
          
          <p>
            A transparência patrimonial e a exatidão dos dados reportados são os pilares de uma declaração segura. No cenário atual, onde os cruzamentos de informações por parte dos órgãos fiscalizadores estão cada vez mais sofisticados, a omissão ou incorreção de valores pode resultar em sanções administrativas e financeiras significativas.
          </p>
          
          <h2>Critérios de Obrigatoriedade e Prazo</h2>
          <p>
            É fundamental que cada indivíduo avalie os critérios de obrigatoriedade fixados para o ano-calendário de 2025. Dentre os parâmetros, destacam-se o limite de rendimentos tributáveis (como salários, aposentadorias e aluguéis), a posse ou propriedade de bens e direitos, a realização de operações em bolsas de valores e o limite de receita bruta para atividades rurais.
          </p>
          
          <p>
            A não observância do prazo estipulado para a entrega acarreta a incidência de multa por atraso (MAED), calculada com base no imposto devido. A CPP Contabilidade recomenda que os contribuintes não posterguem a elaboração do documento, permitindo tempo hábil para a conferência minuciosa dos dados.
          </p>

          <img src={imagemImposto2} alt="Planejamento e organização de documentos fiscais" className={styles.imagemCorpo} />

          <h2>Documentação Necessária e Dedutibilidade</h2>
          <p>
            A organização prévia da documentação é o primeiro passo para uma declaração eficiente. O contribuinte deve reunir os Informes de Rendimentos de todas as fontes pagadoras, comprovantes de despesas dedutíveis (como gastos médicos e de educação, dentro dos limites legais), informações sobre dependentes, além de documentos relativos à aquisição ou venda de bens ocorrida no período.
          </p>
          
          <p>
            É pertinente sublinhar a importância da correta classificação das despesas para a maximização da dedutibilidade legal. A dedução indevida de valores constitui um dos erros mais comuns que levam à retenção da declaração na "Malha Fiscal" (Malha Fina).
          </p>
          
          <p>
            Em conclusão, a Declaração de Imposto de Renda de 2026 exige planejamento e conhecimento técnico. Diante da complexidade da legislação tributária nacional, a CPP Contabilidade coloca-se à disposição para oferecer suporte especializado, garantindo que sua declaração seja elaborada com a máxima segurança jurídica e precisão fiscal.
          </p>
        </article>

      </div>
    </div>
  );
}

export default ImpostoRendaBlog;